export default __webpack_public_path__ + "static/purdue-model-Img-5ce948eee5e301cd89b59da49493cb1b.png";